import { useSelectorMachineContext } from '@printdeal/product-selector';
import { useEffect } from 'react';

/**
 * This hook is used store the current selection of a user in session storage
 * This can be used by external tools like mopinion to act on the current selection
 *
 * This hook can only be used inside the SelectorContext
 */
export const useSaveUserSelection = () => {
  const selection = useSelectorMachineContext((state) => state.context.selection);

  useEffect(() => {
    window?.sessionStorage.setItem('userSelection', JSON.stringify(selection));

    return () => {
      window?.sessionStorage.removeItem('userSelection');
    };
  }, [selection]);
};
